// extracted by mini-css-extract-plugin
export default {"overlay":"dz-z","bodyOpen":"ez-z","content":"fz-z","header":"gz-z","close":"hz-z","closeNoHeading":"iz-z"};